import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import * as yup from "yup";
import MultiSelect from "../../../../components/form/select/MultiSelect";
import Select from "../../../../components/form/select/Select";
import PageTitle from "../../../../components/partials/PageTitle";
import {
  getSingleLifeCover,
  resetUpdateLifeCover,
  updateLifeCover,
} from "../../../../redux/slice/lifecover/lifecoverSlice";

const policies = [
  // { name: 'General Cover', id: '1'},
  { name: "Savings Policy", id: "2" },
  { name: "Credit Life", id: "3" },
];

const multipleData = [
  { name: "Total Contribution", id: "total contribution" },
  { name: "Savings Balance", id: "savings balance" },
];
const SingleCharge = () => {
  const [editing, setEditing] = useState(false);

  const { gl_accounts } = useSelector((state) => state.accounting);
  const multiRef = useRef(null);

  const { id } = useParams();
  const dispatch = useDispatch();

  const { single_life_cover, updateSuccess } = useSelector(
    (state) => state.lifecover
  );

  // const actionArray = JSON.parse(single_life_cover?.action || '[]');

  const breadcrumb = {
    from: {
      title: "Life Cover",
      link: "/admin/settings/life-cover",
    },
    current: {
      title: "Single Life Cover",
      link: null,
    },
  };

  // const defaultMultipleValue =
  //   single_life_cover?.claims === "guaranteed_sum_assured" ||
  //   single_life_cover?.claims === "assumed_sum_assured"
  //     ? []
  //     : (single_life_cover && JSON.parse(single_life_cover?.claims))?.map(
  //         (value) => {
  //           const item = multipleData.find((data) => data.id === value);
  //           return item ? { value: item.id, label: item.name } : null;
  //         }
  //       );

  const onSubmit = (values) => {
    let payload = {...values, id: id};
    // if (values.claims === "multiple") {
    //   const multiple = values?.multiple?.map((item) => item.value);

    //   payload = {
    //     ...values,
    //     multiple: [...multiple],
    //     id: id,
    //   };
    // } else {
    //   payload = { ...values, id: id, multiple: [] };
    // }
    dispatch(updateLifeCover(payload));
  };

  const {
    errors,
    values,
    touched,
    handleBlur,
    handleSubmit,
    handleChange,
    setFieldValue,
    setValues,
    getFieldProps,
    // setFieldError,
    // resetForm,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      life_cover_name: single_life_cover?.life_cover_name,
      policy_category: single_life_cover?.policy_category,
      description: single_life_cover?.description,
      rate: single_life_cover?.rate,
      //   termination: actionArray[0]?.termination || "",
      //   withdrawal: actionArray[0]?.withdrawal || "" ,
      //   maturity: actionArray[0]?.maturity || "",
      asset: single_life_cover?.asset || "",
      liability: single_life_cover?.liability || "",
      // claims:
      //   single_life_cover?.claims !== "guaranteed_sum_assured" &&
      //   single_life_cover?.claims !== "assumed_sum_assured"
      //     ? "multiple"
      //     : single_life_cover?.claims,
      deduction: single_life_cover?.deduction,
      // multiple:
      //   single_life_cover?.claims !== "guaranteed_sum_assured" &&
      //   single_life_cover?.claims !== "assumed_sum_assured"
      //     ? defaultMultipleValue
      //     : [],
    },
    onSubmit,
    // validate: (values) => {
    //   const errors = {};
    //   if (values?.claims === "multiple" && !values.multiple) {
    //     errors.multiple = "Atleast one value must be selected";
    //   }
    //   return errors;
    // },
    validationSchema: () =>
      yup.object().shape({
        life_cover_name: yup.string().required("Life Cover Name is required"),
        policy_category: yup.number().required("Policy Category is required"),
        description: yup.string().required("Description is required"),
        // action: yup.string().test('atLeastOneAction', 'At least one action must be filled', function (value) {
        //     const { termination, withdrawal, maturity } = this.parent;
        //     return termination > 0 || withdrawal > 0 || maturity > 0;
        // }),
        liability: yup.number().required("Liability Gl is required"),
        asset: yup.number().required("Asset Gl is required"),
        rate: yup.number().required("Rate is required"),
      }),
  });

  const policyData = policies?.map((policy) => {
    return {
      label: policy.name,
      value: policy.id,
    };
  });

  const resetFormValues = () => {
    setValues({
      ...values,
      life_cover_name: single_life_cover?.life_cover_name,
      policy_category: single_life_cover?.policy_category,
      description: single_life_cover?.description,
      rate: single_life_cover?.rate,
      //   termination: actionArray[0]?.termination || "",
      //   withdrawal: actionArray[0]?.withdrawal || "",
      //   maturity: actionArray[0]?.maturity || "",
      asset_gl: single_life_cover?.asset_gl || "",
      liability_gl: single_life_cover?.liability_gl || "",
      // claims:
      //   single_life_cover?.claims !== "guaranteed_sum_assured" &&
      //   single_life_cover?.claims !== "assumed_sum_assured"
      //     ? "multiple"
      //     : single_life_cover?.claims,
      deduction: single_life_cover?.deduction,
      // multiple:
      //   single_life_cover?.claims !== "guaranteed_sum_assured" &&
      //   single_life_cover?.claims !== "assumed_sum_assured"
      //     ? defaultMultipleValue
      //     : [],
    });
  };

  useEffect(() => {
    dispatch(getSingleLifeCover(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (updateSuccess) {
      setEditing(false);
      dispatch(getSingleLifeCover(id));
      dispatch(resetUpdateLifeCover());
    }
  }, [dispatch, id, updateSuccess]);

  if (!single_life_cover) {
    return (
      <div className='mt-2'>
        <BeatLoader
          height='80'
          width='80'
          radius='9'
          color='#2e3192'
          ariaLabel='three-dots-loading'
          wrapperStyle={{}}
          wrapperClassName=''
          visible={true}
        />
      </div>
    );
  }
  return (
    <>
      {/* page title */}
      <PageTitle title='Life Cover' breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card '>
            <form onSubmit={handleSubmit}>
              <div className='row p-3'>
                <div className='mb-0 col-md-12'>
                  <label htmlFor='inputEmail4' className='form-label'>
                    Life Cover Name <span className='text-danger'>*</span>
                  </label>
                  {editing ? (
                    <div>
                      <input
                        name='life_cover_name'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.life_cover_name}
                        type='text'
                        className={`form-control form-control-sm mb-2`}
                        placeholder='Charge Name'
                      />
                      {errors?.life_cover_name &&
                        touched?.life_cover_name &&
                        !values?.life_cover_name && (
                          <p className='mb-0 text-danger'>
                            {errors?.life_cover_name + "*"}
                          </p>
                        )}
                    </div>
                  ) : (
                    <p className='form-control border-0 shadow'>
                      {" "}
                      {values?.life_cover_name}
                    </p>
                  )}
                </div>
                <div className='mb-0 col-md-12'>
                  <label htmlFor='account_type' className={`form-label mt-1`}>
                    Policy Category <span className='text-danger'>*</span>
                  </label>

                  {editing ? (
                    <div className=''>
                      <Select
                        onBlur={() => {
                          handleBlur({ target: { name: "policy_category" } });
                        }}
                        name='policy_category'
                        disabled={true}
                        data={policyData}
                        value={values?.policy_category}
                        onChange={(selectedOption) =>
                          setFieldValue(
                            "policy_category",
                            selectedOption?.value
                          )
                        }
                      />
                      {errors?.policy_category &&
                        touched?.policy_category &&
                        !values?.policy_category && (
                          <p className='mb-0 text-danger'>
                            {errors?.policy_category + "*"}
                          </p>
                        )}
                    </div>
                  ) : (
                    <p className='form-control border-0 shadow'>
                      {values?.policy_category === "1" && "General Policy"}
                      {values?.policy_category === "2" && "Savings Policy"}
                      {values?.policy_category === "3" && "Credit Life"}
                    </p>
                  )}
                </div>
                <div className='mb-0 col-md-12 mt-2'>
                  <label htmlFor='account_type' className={`form-label mt-1`}>
                    Description <span className='text-danger'>*</span>
                  </label>
                  {editing ? (
                    <div className=''>
                      <textarea
                        name='description'
                        onBlur={handleBlur}
                        value={values?.description}
                        onChange={handleChange}
                        className={`form-control`}
                        placeholder='Description'
                      />
                      {errors?.description &&
                        touched?.description &&
                        !values.description && (
                          <p className='mb-0 text-danger'>
                            {errors?.description + "*"}
                          </p>
                        )}
                    </div>
                  ) : (
                    <p className='form-control border-0 shadow'>
                      {" "}
                      {values?.description}
                    </p>
                  )}
                </div>
                <div className='mb-0 col-md-12 mt-3'>
                  <label className='form-label my-2'>ACCOUNT</label>
                </div>
                <div className='mb-0 col-md-12'>
                  <label htmlFor='account_type' className={`form-label mt-1`}>
                    Asset <span className='text-danger'>*</span>
                  </label>

                  {editing ? (
                    <div className=''>
                      <Select
                        onBlur={() => {
                          handleBlur({ target: { name: "asset" } });
                        }}
                        name='asset'
                        value={values?.asset}
                        onChange={(selectedOption) =>
                          setFieldValue("asset", selectedOption?.value)
                        }
                        data={gl_accounts?.accounts?.asset_account?.map(
                          (item) => ({
                            label: item?.account_name,
                            value: item?.id,
                          })
                        )}
                        defaultValue={values?.asset}
                      />
                      {errors?.asset && touched?.asset && !values?.asset && (
                        <p className='mb-0 text-danger'>
                          {errors?.asset + "*"}
                        </p>
                      )}
                    </div>
                  ) : (
                    <p className='form-control border-0 shadow'>
                      {
                        gl_accounts?.accounts?.asset_account?.filter(
                          (asset) => asset.id === parseInt(values?.asset)
                        )[0]?.account_name
                      }
                    </p>
                  )}
                </div>
                <div className='mb-0 col-md-12'>
                  <label htmlFor='account_type' className={`form-label mt-1`}>
                    Liability <span className='text-danger'>*</span>
                  </label>

                  {editing ? (
                    <div className=''>
                      <Select
                        onBlur={() => {
                          handleBlur({ target: { name: "liability" } });
                        }}
                        name='liability'
                        value={values?.liability}
                        onChange={(selectedOption) =>
                          setFieldValue("liability", selectedOption?.value)
                        }
                        data={gl_accounts?.accounts?.liability_account?.map(
                          (item) => ({
                            label: item?.account_name,
                            value: item?.id,
                          })
                        )}
                        defaultValue={values?.liability}
                      />
                      {errors?.liability &&
                        touched?.liability &&
                        !values?.liability && (
                          <p className='mb-0 text-danger'>
                            {errors?.liability + "*"}
                          </p>
                        )}
                    </div>
                  ) : (
                    <p className='form-control border-0 shadow'>
                      {
                        gl_accounts?.accounts?.liability_account?.filter(
                          (liability) =>
                            liability.id === parseInt(values?.liability)
                        )[0]?.account_name
                      }
                    </p>
                  )}
                </div>
                <div className='mb-0 col-md-12'>
                  <label htmlFor='inputEmail4' className='form-label mt-1'>
                    Charge Rate (%) <span className='text-danger'>*</span>
                  </label>
                  {editing ? (
                    <div>
                      <input
                        name='rate'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.rate}
                        type='text'
                        className={`form-control form-control-sm mb-2`}
                        placeholder='Charge Rate'
                      />
                      {errors?.rate && touched?.rate && !values?.rate && (
                        <p className='mb-0 text-danger'>{errors?.rate + "*"}</p>
                      )}
                    </div>
                  ) : (
                    <p className='form-control border-0 shadow'>
                      {values?.rate}
                    </p>
                  )}
                </div>
                {/* <div className='mb-0 col-md-12 mt-2'>
                                <label
                                    htmlFor='account_type'
                                    className={`form-label mt-1`}
                                    >
                                    Action Applicable <span className='text-danger'>*</span>
                                </label>
                                <div className='mt-2'>
                                    {(values.termination || editing) && (<div className='d-flex align-items-center'>
                                        <label
                                            className='form-label'
                                            htmlFor='superUser'
                                            style={{
                                            // textAlign: "right",
                                            paddingRight: "5px",
                                            marginBottom: "0px",
                                            width: "15%",
                                            }}
                                        >
                                            Termination(%)
                                        </label>
                                        {editing ? <input
                                            className={`form-control`}
                                            type='number'
                                            value={values?.termination}
                                            name='termination'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            style={{ height: "30px", width: "90px" }}
                                        /> : <span className='form-control border-0 shadow' style={{ height: "30px", width: "90px" }}> {values?.termination}</span>}
                                    </div>)}
                                    {(values.withdrawal || editing) && <div className='d-flex align-items-center pt-2'>
                                        <label
                                            className='form-label'
                                            htmlFor='superUser'
                                            style={{
                                            // textAlign: "right",
                                            paddingRight: "5px",
                                            marginBottom: "0px",
                                            width: "15%",
                                            }}
                                        >
                                            Withdrawal(%)
                                        </label>
                                        {editing ? <input
                                            className={`form-control`}
                                            type='number'
                                            value={values?.withdrawal}
                                            name='withdrawal'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            style={{ height: "30px", width: "90px" }}
                                        /> : <span className='form-control border-0 shadow' style={{ height: "30px", width: "90px" }}> {values?.withdrawal}</span>}
                                    </div>}
                                    {(values.maturity || editing) && <div className='d-flex align-items-center pt-2'>
                                        <label
                                            className='form-label'
                                            htmlFor='superUser'
                                            style={{
                                            // textAlign: "right",
                                            paddingRight: "5px",
                                            marginBottom: "0px",
                                            width: "15%",
                                            }}
                                        >
                                            Maturity(%)
                                        </label>
                                        {editing ? <input
                                            className={`form-control`}
                                            type='number'
                                            value={values?.maturity}
                                            name='maturity'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            style={{ height: "30px", width: "90px" }}
                                        /> : <span className='form-control border-0 shadow' style={{ height: "30px", width: "90px" }}> {values?.maturity}</span>}
                                    </div>}
                                </div>
                                {editing && errors?.action && (
                                    <p className='mb-0 text-danger'>
                                        {errors?.action + '*'}
                                    </p>
                                )}
                            </div> */}
                <div className='mb-0 col-md-12 mt-3'>
                  <label className='form-label'>Life Cover Deduction</label>
                </div>
                {!editing ? (
                  <div>
                    <b className='text-capitalize'>{values?.deduction}</b>
                  </div>
                ) : (
                  <div>
                    <div class='form-check my-1'>
                      <input
                        class='form-check-input mx-1'
                        type='radio'
                        name='deduction'
                        id='deduction'
                        value='deposit transaction'
                        onChange={handleChange}
                        checked={values?.deduction === "deposit transaction"}
                      />
                      <label class='form-check-label' for='company_wide'>
                        Deposit Transaction
                      </label>
                    </div>
                    <div class='form-check'>
                      <input
                        class='form-check-input mx-1'
                        type='radio'
                        name='deduction'
                        value='lumpsum'
                        onChange={handleChange}
                        id='deduction'
                        checked={values?.deduction === "lumpsum"}
                      />
                      <label class='form-check-label' for='lumpsum'>
                        Lumpsum
                      </label>
                    </div>
                  </div>
                )}
                {/* <div className='mb-0 col-md-12 mt-3'>
                  <label className='form-label'>Life Cover Claims</label>
                </div>
                {!editing && (
                  <div>
                    {single_life_cover?.claims === "guaranteed_sum_assured" && (
                      <b>Guaranteed Sum Assured</b>
                    )}
                    {single_life_cover?.claims === "assumed_sum_assured" && (
                      <b>Assumed Sum Assured</b>
                    )}
                    {single_life_cover?.claims !== "guaranteed_sum_assured" &&
                      single_life_cover?.claims !== "assumed_sum_assured" && (
                        <div>
                          <b>Multiple:</b>
                          {defaultMultipleValue.map((item, i) => (
                            <span
                              className='bg-primary text-light fs-6'
                              style={{ padding: "4px", margin: "0px 4px" }}
                              key={i}
                            >
                              {item.label}
                            </span>
                          ))}
                        </div>
                      )}
                  </div>
                )}
                {editing && (
                  <div>
                    <div class='form-check my-1'>
                      <input
                        class='form-check-input mx-1'
                        type='radio'
                        name='claims'
                        id='claims'
                        value='multiple'
                        onChange={handleChange}
                        checked={values?.claims === "multiple"}
                      />
                      <label class='form-check-label' for='company_wide'>
                        Multiple
                      </label>
                      {values?.claims === "multiple" && (
                        <div className='ms-3'>
                          <MultiSelect
                            isError={errors?.multiple && touched?.multiple}
                            name='multiple'
                            field={{ ...getFieldProps("multiple") }}
                            data={multipleData?.map((item, i) => ({
                              label: item?.name,
                              value: item?.id,
                            }))}
                            onChange={setFieldValue}
                            onBlur={() => {
                              handleBlur({ target: { name: "multiple" } });
                            }}
                            // defaultValue={JSON.parse(single_life_cover?.claims)?.map((value) => {
                            //    const mappedValue = {label: multipleData.find(item => item.id === value)?.name,
                            //     value: value}
                            //      return mappedValue;
                            // })}
                            defaultValue={values.multiple?.map(({ value }) => {
                              const mappedValue = {
                                label: multipleData.find(
                                  (item) => item.id === value
                                )?.name,
                                value: value,
                              };
                              return mappedValue;
                            })}
                            errors={errors}
                            touched={touched}
                            disabled={values?.claims !== "multiple"}
                            ref={multiRef}
                          />
                        </div>
                      )}
                    </div>
                    <div class='form-check'>
                      <input
                        class='form-check-input mx-1'
                        type='radio'
                        name='claims'
                        value='assumed_sum_assured'
                        onChange={handleChange}
                        id='claims'
                        checked={values?.claims === "assumed_sum_assured"}
                      />
                      <label class='form-check-label' for='rab'>
                        Assumed Sum Assured
                      </label>
                    </div>
                    <div class='form-check'>
                      <input
                        class='form-check-input mx-1'
                        type='radio'
                        name='claims'
                        value='guaranteed_sum_assured'
                        onChange={handleChange}
                        id='claims'
                        checked={values?.claims === "guaranteed_sum_assured"}
                      />
                      <label class='form-check-label' for='rab'>
                        Guaranteed Sum Assured
                      </label>
                    </div>
                  </div>
                )} */}
              </div>
              <div className='row p-3 mb-3 mt-1'>
                {/* <div className='col-md-3 col-lg-2'></div> */}
                <div className='col-md-7 col-lg-6'>
                  {!editing && (
                    <button
                      onClick={() => setEditing(true)}
                      className='btn btn-primary btn-sm px-4 rounded'
                    >
                      <span>Edit</span>
                    </button>
                  )}
                  {editing && (
                    <div className='d-flex gap-2'>
                      <button
                        onClick={() => {
                          setEditing(false);
                          resetFormValues();
                        }}
                        className='btn btn-secondary btn-sm px-4 rounded'
                      >
                        <span>Cancel</span>
                      </button>
                      <button
                        type='submit'
                        className='btn btn-primary btn-sm px-4 rounded'
                      >
                        <span>Update</span>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleCharge;
